import React from 'react';
import { ExclamationCircleOutlined, HomeOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { logout } from '../../../store/oidc';
import VctorsLogo from '../../../assets/images/vctors-logo.svg';
import { VButton } from '../../../modules/common/components/button/button.styles';

const WrongPortalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
`;

const ContentCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 60px 40px;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
`;

const LogoWrapper = styled.div`
  margin-bottom: 20px;
  
  img {
    height: 60px;
    width: auto;
  }
`;

const IconWrapper = styled.div`
  margin-bottom: 30px;
  
  .anticon {
    font-size: 80px;
    color: #ff6b6b;
  }
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
`;

const Description = styled.p`
  font-size: 16px;
  color: #7f8c8d;
  line-height: 1.6;
  margin-bottom: 30px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
`;



const WrongPortal: React.FC = () => {
  const handleGoToStaffPortal = () => {
    window.location.href = process.env.REACT_APP_STAFF_PORTAL_URL || 'https://staff.medicaltravel.com';
  };

  const handleGoToPatientPortal = () => {
    window.location.href = process.env.REACT_APP_PATIENT_PORTAL_URL || 'https://patient.medicaltravel.com';
  };

  const handleGoToDoctorPortal = () => {
    window.location.href = process.env.REACT_APP_DOCTOR_PORTAL_URL || 'https://doctor.medicaltravel.com';
  };

  const handleLogout = async () => {
    try {
      // Check if OIDC authentication is enabled
      const isOidcEnabled = process.env.REACT_APP_AUTH_KEY_CLOAK && 
                           process.env.REACT_APP_AUTH_KEY_CLOAK.toLowerCase() === 'true';
      
      if (isOidcEnabled) {
        // Use the proper OIDC logout function which handles:
        // - Clearing local storage
        // - Removing user from OIDC storage
        // - Signing out from Keycloak/OIDC provider
        // - Redirecting to the appropriate page
        await logout();
      } else {
        // For basic authentication, just clear local data and redirect
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/signin';
      }
    } catch (error) {
      console.error('Logout error:', error);
      // Fallback: clear local data and redirect manually
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = '/signin';
    }
  };

  const getCurrentPortalName = () => {
    const portalName = process.env.REACT_APP_PORTAL_NAME;
    switch (portalName) {
      case 'staff':
        return 'Staff Portal';
      case 'patient':
        return 'Patient Portal';
      case 'doctor':
        return 'Doctor Portal';
      default:
        return 'Portal';
    }
  };

  return (
    <WrongPortalWrapper>
      <ContentCard>
        <LogoWrapper>
          <img src={VctorsLogo} alt="Vctors Logo" />
        </LogoWrapper>
        
        {/* <IconWrapper>
          <ExclamationCircleOutlined />
        </IconWrapper> */}
        
        <Title>Wrong Portal Access</Title>
        
        <Description>
          You don't have access to this portal 
          Your account may be registered for a different portal. 
          Please try accessing the correct portal.
        </Description>

        {/* <ButtonGroup>
          <StyledButton 
            type="primary" 
            icon={<HomeOutlined />}
            onClick={handleGoToStaffPortal}
          >
            Staff Portal
          </StyledButton>
          
          <StyledButton 
            type="primary" 
            icon={<HomeOutlined />}
            onClick={handleGoToPatientPortal}
          >
            Patient Portal
          </StyledButton>
          
          <StyledButton 
            type="primary" 
            icon={<HomeOutlined />}
            onClick={handleGoToDoctorPortal}
          >
            Doctor Portal
          </StyledButton>
        </ButtonGroup> */}

                  <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center' }}>
            <VButton 
              vType="primary" 
              variant="lg"
              onClick={handleLogout}
            >
              Try Different Account
            </VButton>
          </div>
      </ContentCard>
    </WrongPortalWrapper>
  );
};

export default WrongPortal; 